import { renderDate } from '../utility/personTabGridHelper';

export const DICT_SELECT_PROPS = {
  optionValue: 'Code',
  optionLabel: 'Description',
  showLabelOnly: false,
};

export const PARTY_KIND_SELECT_PROPS = {
  optionValue: 'Code',
  optionLabel: 'Description',
  showLabelOnly: true,
};

export const DEFAULT_VALUES = {
  ptsVehicleID: null,
  Make: '',
  Model: '',
  Year: '',
  VIN: '',
  Style: '',
  Color: '',
  PlateNumber: '',
  PlateState: '',
  PlateType: '',
  PlateExpiration: null,
  ptsPlateIssuingAuthorityID: null,
  ptsAddressID: null,
  PlateColor: '',
  PlateBackgroundText: '',
  PlateStatus: '',
  DecalExpiration: null,
  PlateDetail: '',
  TitleText: '',
  InsuranceCompany: '',
  VehicleValue: '',
  OdometerReading: '',
  GrossWeightMeasure: '',
  isPermanentReg: false,
  RoadIndicator: false,
  IsLeased: false,
  LesseeType: 'Person',
  ptsLesseeID: null,
  LessorType: 'Person',
  ptsLessorID: null,
};

export const VEHICLE_REG_GRID_COLUMNS = [
  { field: 'ptsRegistrationID', headerName: 'Registration ID', width: 160 },
  { field: 'PlateType', headerName: 'Plate Type', width: 150 },
  { field: 'PlateColor', headerName: 'Plate Color', width: 150 },
  { field: 'PlateNumber', headerName: 'Plate Number', width: 160 },
  { field: 'PlateState', headerName: 'Plate State', width: 140 },
  { field: 'PlateBackgroundText', headerName: 'Background Text', width: 180 },
  { field: 'PlateDetail', headerName: 'Plate Detail', width: 160 },
  { field: 'PlateStatus', headerName: 'Plate Status', width: 150 },
  {
    field: 'PlateExpiration',
    headerName: 'Plate Expiration',
    width: 180,
    valueFormatter: renderDate,
  },
  { field: 'OdometerReading', headerName: 'Odometer Reading', width: 180 },
  { field: 'InsuranceCompany', headerName: 'Insurance Company', width: 190 },
  { field: 'VehicleValue', headerName: 'Vehicle Value', width: 160 },
  { field: 'Created', headerName: 'Created', width: 180, valueFormatter: renderDate },
  { field: 'CreatedBy', headerName: 'Created By', width: 160 },
  { field: 'Updated', headerName: 'Updated', width: 180, valueFormatter: renderDate },
  { field: 'UpdatedBy', headerName: 'Updated By', width: 160 },
];
